import script from "./PurchaseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__